import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";
import { API } from "@/config";

/* REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH */
export const AuthCallback = () => {
  const nav = useNavigate();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const sessionId = params.get("session_id");
    if (!sessionId) { nav("/login?role=customer", { replace: true }); return; }
    (async () => {
      try {
        const { data } = await axios.post(`${API}/auth/customer/google`, { session_id: sessionId });
        toast.success(`Welcome, ${data.name || data.email}!`);
        window.location.replace("/account");
      } catch (e) {
        toast.error("Google sign-in failed — please try again.");
        nav("/login?role=customer", { replace: true });
      }
    })();
  }, [nav]);
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="glass p-8 text-center">
        <Sparkles className="w-8 h-8 mx-auto text-[#FFD166] mb-3" />
        <p className="font-serif text-2xl">Signing you in…</p>
      </div>
    </div>
  );
};
